import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CustomerService } from '@/api/services/CustomerService'

export const useDeleteCustomer = (userId: string) => {
  const queryClient = useQueryClient()

  const {
    mutate: deleteCustomer,
    isPending,
    error,
  } = useMutation({
    mutationKey: ['delete-customer'],
    mutationFn: () => CustomerService.deleteCustomer(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] })
    },
  })

  return { deleteCustomer, isPending, error }
}
